// Mortgage
export const PRODUCT_MORTGAGE = 'mortgage';
export const PROTOCOL_MORTGAGE = 'api';

// OAO
export const PRODUCT_OAO = 'oao';
export const PROTOCOL_OAO = 'api';
